import * as React from "react";
import { forwardRef, memo } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFilledNextArrowIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "1rem",
	height: "1rem",
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("rect", {
			y: 27.4668,
			width: 15.0544,
			height: 22.4827,
			rx: 2,
			transform: "rotate(-90 0 27.4668)",
			fill: "#30515B"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.5728 7.56453C18.5728 5.90472 20.4779 4.96723 21.793 5.97991L37.9422 18.4155C38.9819 19.2161 38.9819 20.7841 37.9422 21.5847L21.793 34.0203C20.4779 35.033 18.5728 34.0955 18.5728 32.4357L18.5728 7.56453Z",
			fill: "#30515B"
		})
	]
});
const ForwardRef = forwardRef(SvgFilledNextArrowIcon);
const Memo = memo(ForwardRef);
export default Memo;
